import addYears from 'date-fns/addYears';
import { formatDate } from 'utils/date/formatDate';

export function addLongTermOptions(groups) {
  const DEFAULT_DATE_NO_DATE = addYears(new Date(), 10);
  const DEFAULT_MAX_DATE = addYears(new Date(), 3);
  const lastIndex = groups.length - 1;
  const longTermOptions = [
    {
      text: `Em ${DEFAULT_MAX_DATE.getFullYear()}`,
      value: formatDate(DEFAULT_MAX_DATE, 'iso-string'),
    },
    {
      text: 'Sem previsão',
      value: formatDate(DEFAULT_DATE_NO_DATE, 'iso-string'),
    },
  ];

  longTermOptions.forEach((option) => {
    groups[lastIndex]?.dates.push(option);
  });

  return groups;
}
